export default __webpack_public_path__ + "static/media/makePayment.28b36e88.svg";